// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_RemoverDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /despesas/remover_despesa/{despesa_id}
 *
 * Delete operation — `dados` is always null. Operation success is signaled
 * by the envelope's `success` flag. Failure paths use $this->sendError(...)
 * in the controller; no ResponseContract is needed for errors.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_RemoverDespesaResponseDados = null;

export type Despesas_RemoverDespesaResponse = ApiResponse<Despesas_RemoverDespesaResponseDados>;

registerResponseContract('Despesas_RemoverDespesaResponse', {})
